import { render, staticRenderFns } from "./PackageSettingType.vue?vue&type=template&id=ca05dbda"
import script from "./PackageSettingType.vue?vue&type=script&lang=js"
export * from "./PackageSettingType.vue?vue&type=script&lang=js"
import style0 from "./PackageSettingType.vue?vue&type=style&index=0&id=ca05dbda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports